<template>
  <div :class="['spinner','spinner-border-sm','spinner-' + tipo, bgColor, (visivel ? '' : 'd-none'), classes]" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</template>

<script>
export default {
  name: 'Spinner',
  props: {
    tipo: {
      default: 'border' 
    },
    visivel: {
      default: true
    },
    classes: String,
    bg: String,
  },
  computed: {
    bgColor() {
      return (this.bg ? 'text-' + this.bg : '')
    }
  }
}
</script>

<style scoped></style>